

@if (isDropFile) {
  <div class="drop-wrap">
    @if (!file) {
      <div
        class="drop-zone"
        [class.active]="isDragging"
        (dragover)="onDragOver($event)"
        (dragleave)="onDragLeave($event)"
        (drop)="onDrop($event)"
        >
        <p>
          {{ "NEW_INJECTS.DRAG_DROP" | translate }}
          <span class="browse" (click)="fileDropInput.click()">{{
            "NEW_INJECTS.BROWSE" | translate
          }}</span>
        </p>
        <input
          type="file"
          #fileDropInput
          [accept]="accept"
          (change)="fileInputOnChange($event)"
          hidden
          />
      </div>
    }
    @if (file) {
      <div class="uploaded-files d-flex align-items-center">
        <mat-icon class="file-icon">description</mat-icon>
        <div class="file-wrap">
          <div class="file-name">{{ displayFileName }}</div>
          <div class="file-data">
            {{ date | date : "dd MMM, yyyy" }} • {{ file?.size | fileSize }}
          </div>
          <mat-progress-bar
            class="upload-progress-bar"
            [value]="progress"
          ></mat-progress-bar>
          <div class="status-success" [hidden]="!isSuccess">
            <mat-icon>check</mat-icon>
            Uploaded
            <mat-icon (click)="removeFile()" class="remove-file"
              >delete_outline</mat-icon
              >
            </div>
            <div class="status-danger" [hidden]="!correctSize">
              Your file must be under 512 MB
            </div>
          </div>
        </div>
      }
    </div>
  } @else {
    <div class="upload-group" [class.aligned]="aligned">
      <input
        id="input-file-id"
        type="file"
        hidden="hidden"
        (change)="fileInputOnChange($event)"
        [accept]="accept"
        #fileInput
        />
      @if (isShowButton) {
        <label class="btn btn-primary" for="input-file-id">{{
          "ADMIN.UPLOAD.BROWSE_FILE" | translate
        }}</label>
      }
      @if (file) {
        <table class="table" aria-describedby="files list">
          <thead>
            <tr>
              <th>{{ "ADMIN.UPLOAD.NAME" | translate }}</th>
              <th>{{ "ADMIN.UPLOAD.SIZE" | translate }}</th>
              <th>{{ "ADMIN.UPLOAD.PROGRESS" | translate }}</th>
              <th>{{ "ADMIN.UPLOAD.STATUS" | translate }}</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td class="item-name">
                <strong>{{ displayFileName }}</strong>
              </td>
              <td>{{ file.size | fileSize }}</td>
              <td>
                <mat-progress-bar
                  class="upload-progress-bar"
                  [value]="progress"
                ></mat-progress-bar>
              </td>
              <td class="item-status">
                @if (!correctSize) {
                  <span class="error-size">{{
                    "ADMIN.UPLOAD.TOO_BIG" | translate
                    }}</span
                    >
                    }<span class="material-icons">{{ icon }}</span>
                  </td>
                </tr>
              </tbody>
            </table>
            @if (!icon) {
              <button
                class="btn btn-success"
                (click)="upload()"
                [disabled]="!correctSize"
                type="button"
                >
                {{ "ADMIN.UPLOAD.UPLOAD" | translate }}
              </button>
            }
          }
        </div>
      }
